function footer() {
	const menuContainer = document.querySelector('#menu-footer_navigation_1-container');

	if (!menuContainer) return;

	const questions = menuContainer.querySelectorAll(
		':scope > .menu-item.menu-item-type-custom > a'
	);

	questions.forEach((question) => {
		question.addEventListener('click', function (e) {
			e.preventDefault();

			const allAnswers = menuContainer.querySelectorAll(
				':scope > .menu-item.menu-item-type-custom > .sub-menu'
			);
			const allQuestions = menuContainer.querySelectorAll(
				':scope > .menu-item.menu-item-type-custom > a'
			);

			allQuestions.forEach((q) => q.classList.remove('open'));
			allAnswers.forEach((a) => (a.style.display = 'none'));

			const parentItem = this.closest('.menu-item.menu-item-type-custom');
			const answer = parentItem.querySelector(':scope > .sub-menu');

			if (this.classList.contains('open')) {
				this.classList.remove('open');
				if (answer) answer.style.display = 'none';
			} else {
				this.classList.add('open');
				if (answer) answer.style.display = 'block';
			}
		});
	});
}

export { footer };
